export default "__VITE_ASSET__2GRHiBXr__"